import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const AddColumnInline: React.FC<{ onCreate: (title: string) => void; onCancel: () => void }> = ({ onCreate, onCancel }) => {
  const [title, setTitle] = React.useState("");
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleCreate = () => {
    const t = title.trim();
    if (!t) return;
    onCreate(t);
    setTitle("");
  };

  return (
    <Card className="bg-board-column border-none shadow-sm transition-all animate-in fade-in zoom-in duration-200">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">New Column</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Input
          ref={inputRef}
          placeholder="Column title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleCreate();
          }}
        />
        <div className="flex items-center gap-2">
          <Button size="sm" variant="ghost" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="sm" onClick={handleCreate} disabled={!title.trim()}>
            Create
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
